import React from 'react';

export type FilterType = 'contains' | 'not_contains' | 'exact' | 'not_exact';
export const FILTER_TYPE_LABELS: Record<FilterType, string> = {
  contains: 'Contains',
  not_contains: "Doesn't Contain",
  exact: 'Exact Match',
  not_exact: "Doesn't Match Exact"
};

interface SearchFilterProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  filterType: FilterType;
  onFilterTypeChange: (type: FilterType) => void;
  placeholder?: string;
}

export const SearchFilter: React.FC<SearchFilterProps> = ({
  searchTerm,
  onSearchChange,
  filterType,
  onFilterTypeChange,
  placeholder = "Search by SKU or product name (comma-separated for multiple)"
}) => {
  return (
    <div className="search-filter" style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
      <input 
        type="text" 
        className="search-input search-input-small-placeholder"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        style={{ minWidth: 0, flex: 1, fontSize: '1em', padding: '0.6em 1em', borderRadius: 8, border: '1px solid #ddd', height: 36 }}
      />
      <select
        className="search-filter-type-dropdown"
        value={filterType}
        onChange={e => onFilterTypeChange(e.target.value as FilterType)}
        style={{ height: 36, fontSize: '1em', borderRadius: 8, border: '1px solid #ddd', padding: '0 8px' }}
      >
        {Object.entries(FILTER_TYPE_LABELS).map(([key, label]) => (
          <option key={key} value={key}>{label}</option>
        ))}
      </select>
    </div>
  );
}; 